import Vue from "vue";
var obj = {
  industry_type: [
    {
      id: 1,
      text: "IT互联网",
    },
    {
      id: 2,
      text: "金融",
    },
    {
      id: 3,
      text: "教育",
    },
    {
      id: 4,
      text: "医疗",
    },
    {
      id: 5,
      text: "制造",
    },
    {
      id: 6,
      text: "政府",
    },
    {
      id: 7,
      text: "其他",
    },
  ],
  staff_size: [
    {
      id: 1,
      text: "1-20人",
    },
    {
      id: 2,
      text: "21-100人",
    },
    {
      id: 3,
      text: "101-500人",
    },
    {
      id: 4,
      text: "500人以上",
    },
  ],
};
Vue.prototype.$dic = obj;
